// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2rMDk","bigColWidth":"Table_bigColWidth__2yiOv","biggerColWidth":"Table_biggerColWidth__1k5tG","row":"Table_row__rrTx8","col":"Table_col__D0g_Z"};